module.exports = __webpack_public_path__ + "img/missions_image.6c56ccc5.png";